module.exports = __webpack_public_path__ + "static/media/logo.111c5e2f.jpg";